import i18n from '@/plugins/i18n';

export class ProjectZone {

    public static Default(selected: boolean = false): ProjectZone {
        return new ProjectZone({ id: 0, name: i18n.t('common.ellipsis'), selected });
    }

    public id: number = 0;
    public name?: string;
    public localizedName!: any;
    public selected: boolean = false;

    get value(): number | undefined {
        return this.id;
    }

    get text(): string | undefined {
        let text = this.name;

        if (text === i18n.t('common.ellipsis').toString()) {
            return text;
        }

        if (this.localizedName) {
            const resource = this.localizedName.find((l: any) => l.culture === i18n.locale)!.resource;
            text = resource[Object.keys(resource)[0]];
        }

        return text ? i18n.t(text).toString() : undefined;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json, { localizedName: json.localizedName ? JSON.parse(json.localizedName) : null });

        if (this.localizedName) {
            this.localizedName.forEach((name: any) => {
                i18n.mergeLocaleMessage(name.culture, name.resource);
            });
        }
    }

    public clone(): ProjectZone {
        const zone = new ProjectZone();

        zone.id = this.id;
        zone.name = this.name;
        zone.localizedName = this.localizedName;
        zone.selected = this.selected;

        return zone;
    }
}
